define('core/templates/postMediaUploadProgress',['handlebars', 'handlebars.partials', 'core/extensions/handlebars.helpers'], function(Handlebars) {

return Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    return "<li>\n<div class=\"media-progress-box\">\n<div class=\"media-progress\">\n<div class=\"bar\" style=\"right: "
    + container.escapeExpression(container.lambda((depth0 != null ? depth0.remainingPerc : depth0), depth0))
    + "%\"></div>\n</div>\n</div>\n</li>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers.each.call(depth0 != null ? depth0 : {},(depth0 != null ? depth0.collection : depth0),{"name":"each","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "");
},"useData":true})

});
